import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./Sidebar.css";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link, useNavigate } from "react-router-dom";
import HeaderSearch from "../Header/Search/Search";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import AIIcon from "../../Assets/AIIcon.svg";
import backarrow from "../../Assets/backarrow.svg";
import pathai from "../../Assets/pathAi.svg";
import archive from "../../../src/Assets/archivehead.png";
import intell from "../../../src/Assets/intell.png";
import LogoutIcon from "@mui/icons-material/Logout";
import ChevronDownIcon from "@mui/icons-material/ChevronRight";
import cellphone from "../../../src/Assets/cellphone.svg";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import JobsLogo from "../../Assets/orbit_logo_transparent.png";
import starActive from "../../../src/Assets/staractive.svg";
import enrich from "../../../src/Assets/enrich.svg";
import {
  AI_DECISION_MAKER,
  AI_LEADS,
  AI_PATH,
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMING_SOON,
  COMPANY_PROFILE_SCREEN,
  DATA_ENRICH,
  FAVORITES,
  TRACKING,
  Archived,
  FAVORITES_LIST,
  ORBIT_INTEL_CHAT,
} from "../../Utils/Constants";
import {
  APIDataUrl,
  APITokenUrl,
  GetOktaAuthData,
  GetUserId,
} from "../../Utils/Utils";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../Loader/Loader";
import aiChatIcon from "../../Assets/ai-chat.svg";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));
export default function Sidebar({
  setRefState,
  refState,
  setRefStatenew,
  refStatenew,
}) {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const getAuthData = GetOktaAuthData();
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const userId = GetUserId();
  const loggedUser = GetOktaAuthData();
  const [leadsProfileData, setLeadsProfileData] = React.useState([]);
  const [decisionMakerData, setDecisionMakerData] = React.useState([]);
  const [isLoadProfile, setIsLoadProfile] = React.useState(false);
  const [isStateNew, setIsStateNew] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openLogout = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const LeadsProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_filter_org?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        setLeadsProfileData(e?.data?.data);
        setRefState(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    if (isLoadProfile) {
      if (userId || refState) {
        LeadsProfile();
      }
    } else {
      setIsLoadProfile(true);
    }
  }, [userId, refState, isLoadProfile]);
  const decisionMakerProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_filter_people?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        setDecisionMakerData(e?.data?.data);
        setRefStatenew(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    if (isStateNew) {
      if (userId || refStatenew) {
        decisionMakerProfile();
      }
    } else {
      setIsStateNew(true);
    }
  }, [userId, refStatenew, isStateNew]);

  const loggingOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  const generateLastSessionReport = async () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/generate_last_session_report?user_email=${
        loggedUser?.user?.profile?.username
      }`,
    };
    axios(option)
      .then(() => {})
      .catch(() => {});
  };

  const goToArchive = () => {
    navigate("/Archived");
  };


  return (
    <>
      <CssBaseline />
      {loading ? <Loader /> : null}

      <AppBar
        position="fixed"
        open={open}
        className={open ? "main-header" : "main-headernew"}
      >
        <Toolbar className="toolbar-header">
          {open ? (
            <DrawerHeader className="header-main">
              {window.location.pathname === AI_PROFILE_FORM_TABLE ||
              window.location.pathname === AI_PROSPECT_PROFILE ||
              window.location.pathname === COMPANY_PROFILE_SCREEN ? (
                <div>
                  <List>
                    <ListItem className="arrowbutton-item-list">
                      <ListItemButton
                        className="backarrow-list-button"
                        onClick={() => {
                          if (
                            window.location.pathname ===
                            COMPANY_PROFILE_SCREEN
                          ) {
                            navigate(AI_LEADS);
                          } else {
                            navigate("/aiprofile/0");
                          }
                        }}
                      >
                        <div className="backarrow-header-main">
                          <img src={backarrow} alt="" />
                        </div>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </div>
              ) : null}
              {window?.location?.pathname === "/tracking" ? null : (
                <HeaderSearch setLoading={setLoading} />
              )}
            </DrawerHeader>
          ) : (
            <DrawerHeader className="header-main">
              {window.location.pathname === AI_PROFILE_FORM_TABLE ||
              window.location.pathname === AI_PROSPECT_PROFILE ||
              window.location.pathname === COMPANY_PROFILE_SCREEN ? (
                <div>
                  <List>
                    <ListItem className="arrowbutton-item-list">
                      <ListItemButton
                        className="backarrow-list-button"
                        onClick={() => {
                          if (
                            window.location.pathname ===
                            COMPANY_PROFILE_SCREEN
                          ) {
                            navigate(AI_LEADS);
                          } else {
                            navigate("/aiprofile/0");
                          }
                        }}
                      >
                        <div className="backarrow-header-main">
                          <img src={backarrow} alt="" />
                        </div>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </div>
              ) : null}

              <HeaderSearch />
            </DrawerHeader>
          )}
          <div className="bellicon-profileimage">
            <div className="image-and-information">
              <div className="header-user-name">
                <p className="letter-heading">
                  {getAuthData?.user?.profile?.firstName?.charAt(0)}
                  {getAuthData?.user?.profile?.lastName?.charAt(0)}
                </p>
              </div>
              {/* <img src={userprofile} alt="logo" className="userprofile-image" /> */}
              <div className="username-and-role">
                <p className="user-name-header">
                  {`${getAuthData?.user?.profile?.firstName} ${getAuthData?.user?.profile?.lastName}`}
                </p>
                {/* <p className="user-name-header-designation">Designation</p> */}
              </div>
            </div>
            <div className="Leades-filter-inner-container-header">
              <Button
                style={{ textTransform: "none" }}
                id="action-button"
                aria-controls={openLogout ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openLogout ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleMenuClick}
                endIcon={
                  <ExpandMoreOutlinedIcon className="down-arrow-header" />
                }
              ></Button>
              <StyledMenu
                className="custom-menu"
                id="action-menu"
                MenuListProps={{
                  "aria-labelledby": "action-button",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <div>
                  <MenuItem
                    className="AI-Leads-button-drop-down-up-header"
                    onClick={handleMenuClose}
                    disableRipple
                  >
                    <p
                      className="push-to-slaesforce-in-button"
                      // onClick={() => loggingOut()}
                      onClick={goToArchive}
                    >
                      <span className="head-drop-menu">
                        <img src={archive} alt="archive" />
                      </span>
                      Archived Records
                    </p>
                  </MenuItem>
                  <MenuItem
                    className="AI-Leads-button-drop-down-up-header"
                    onClick={handleMenuClose}
                    disableRipple
                  >
                    <p
                      className="push-to-slaesforce-in-button"
                      onClick={() => loggingOut()}
                    >
                      <span className="head-drop-menu">
                        <LogoutIcon style={{ fontSize: 18 }} />
                      </span>
                      Logout
                    </p>
                  </MenuItem>
                </div>
              </StyledMenu>
            </div>
          </div>

          <IconButton
            className="Siderbarresponsivebutton"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        className={
          open ? "mobileresponsiveMaincsss" : "mobileresponsiveMaincsssnew"
        }
        variant="permanent"
        open={open}
      >
        <DrawerHeader
          className={`${open ? "header-section-sidebar" : ""}`}
          //  style={{ marginTop: "30px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Link
              to={"/dashboard"}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={JobsLogo}
                alt="logo"
                className="logo-image-of-the-project"
              />
            </Link>
          </div>
        </DrawerHeader>
        {/* <Divider /> */}
        <div className="main-sidebar-pages-and-addsearch-data">
          <div className={`all-sidebar-listitems`}>
            {/* Dashboard */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to="/dashboard"
                  selected={window.location.pathname === "/dashboard"}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <ExploreOutlinedIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Dashboard"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>

            {(
              <List>
                <ListItem
                  disablePadding
                  sx={{ display: "block" }}
                  className="links-sidebar"
                >
                  <ListItemButton
                    component={Link}
                    to={ORBIT_INTEL_CHAT}
                    selected={
                      window.location.pathname === ORBIT_INTEL_CHAT
                    }
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      {window.location.pathname === ORBIT_INTEL_CHAT ? (
                        <span className="outer_circle_sidebar">
                          <img src={aiChatIcon} alt="Orbit Intel Chat" />
                        </span>
                      ) : (
                        <img src={aiChatIcon} alt="Orbit Intel Chat" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={"Orbit Intel Chat"}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </List>
            )}
            {/* AI Leads */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={AI_LEADS}
                  selected={window.location.pathname === AI_LEADS}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {window.location.pathname === AI_LEADS ? (
                      <span className="outer_circle_sidebar">
                        <img src={AIIcon} alt="" />
                      </span>
                    ) : (
                      <span>
                        <img src={AIIcon} alt="" />
                      </span>
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={"AI Leads"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* Ai Prospects */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={AI_DECISION_MAKER}
                  selected={window.location.pathname === AI_DECISION_MAKER}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <PeopleAltOutlinedIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"AI Prospects "}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* AI PAth */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={AI_PATH}
                  selected={window.location.pathname === AI_PATH}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {window.location.pathname === AI_PATH ? (
                      <span className="outer_circle_sidebar">
                        <img src={pathai} alt="" />
                      </span>
                    ) : (
                      <img src={pathai} alt="" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={"AI Path"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* Favorites */}
            {/* <List>
          <ListItem
            disablePadding
            sx={{ display: "block" }}
            className="links-sidebar"
          >
            <ListItemButton
              component={Link}
              to={FAVORITES}
              selected={window.location.pathname === FAVORITES}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                {window.location.pathname === FAVORITES ? (
                  <span className="outer_circle_sidebar">
                    <img src={starActive} alt="" />
                  </span>
                  // <img src={starFilled} alt="" />
                ) : (
                  <img src={starActive} alt="" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={"Favorites"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        </List> */}
            {/* Favorites List New  */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={FAVORITES_LIST}
                  selected={window.location.pathname === FAVORITES_LIST}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {window.location.pathname === FAVORITES_LIST ? (
                      <span className="outer_circle_sidebar">
                        <img src={starActive} alt="" />
                      </span>
                    ) : (
                      // <img src={starFilled} alt="" />
                      <img src={starActive} alt="" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={"Favorites"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* Data Enrich */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={DATA_ENRICH}
                  selected={window.location.pathname === DATA_ENRICH}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {window.location.pathname === DATA_ENRICH ? (
                      <span className="outer_circle_sidebar">
                        <img src={enrich} alt="" />
                      </span>
                    ) : (
                      <img src={enrich} alt="" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={"Data Enrich"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* Tracking */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={TRACKING}
                  selected={window.location.pathname === TRACKING}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {window.location.pathname === TRACKING ? (
                      <span className="outer_circle_sidebar">
                        <img src={intell} alt="" />
                      </span>
                    ) : (
                      <img src={intell} alt="" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={"Competitive Intel"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* AI Profile */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={"/aiprofile/0"}
                  selected={window.location.pathname.includes("aiprofile")}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <AccountCircleOutlinedIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"AI Profile"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            
            <List>
            </List>
          </div>
          
        </div>
      </Drawer>

    </>
  );
}
